import React from 'react';
import { Banner, spacer20 } from '@spotify-internal/encore-web';
import styled from 'styled-components';

import { useTranslation } from 'providers/translations/TranslationProvider';
import { useServerSideConstants } from 'providers/ServerSideConstantsProvider';
import { isSupportedMessagingLocale } from 'utils/market/market';

const StyledBanner = styled(Banner)`
  margin-bottom: ${spacer20};
`;

const EnglishOnlySupportBanner = () => {
  const { t } = useTranslation();
  const {
    market: { locale },
    verticalConfig: {
      locales: { messagingLocales },
    },
  } = useServerSideConstants();

  if (isSupportedMessagingLocale(locale, messagingLocales)) {
    return null;
  }

  return <StyledBanner colorSet="announcement">{t('contact_in_english_only')}</StyledBanner>;
};

export default EnglishOnlySupportBanner;
